import { render, staticRenderFns } from "./filtroClients.vue?vue&type=template&id=40a5b34d"
import script from "./filtroClients.vue?vue&type=script&lang=js"
export * from "./filtroClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports